import 'whatwg-fetch'

import isWithinRange from 'date-fns/is_within_range'
import { getCookie, setCookie } from 'tiny-cookie'

const modal = {
  enable: (consent) => {
    const modals = Array.from(document.querySelectorAll('.c-modal'))

    modals.map((moda) => {
      moda.addEventListener('click', (e) => {
        if (e.target === e.currentTarget) {
          const modalType = e.target.classList.contains('c-modal')
            ? e.target.classList[1].replace('c-', '')
            : e.target.parentNode.parentNode.classList[1].replace('c-', '')
          const modalTypeActive = `${modalType}--active`

          if (modalType === 'modal--discount' && consent) {
            window.sessionStorage.setItem('seedlip_discount', true)
          }

          if (modalType === 'modal--newsletter' && consent) {
            setCookie('seedlip-stored-modal-newsletter', true)
          }

          document.body.classList.remove(modalTypeActive)
        }
      })

      return true
    })

    modal.listeners(consent)
  },

  show_discount: (userCountry, storedCountryCode) => {
    // if store is uk and date is between 1st jan and 31st jan
    // used in Country-Selector.js
    const discountSeen = window.sessionStorage.getItem('seedlip_discount')
    const newsletterSeen = getCookie('seedlip-stored-modal-newsletter', true)

    if (
      !discountSeen &&
      userCountry === 'gb' &&
      window.store_country === 'United Kingdom' &&
      isWithinRange(new Date(), new Date(2018, 0, 1), new Date(2018, 1, 1))
    ) {
      setTimeout(() => {
        document.body.classList.add('modal--discount--active')
      }, 3000)
    } else if (
      !discountSeen &&
      userCountry !== 'gb' &&
      storedCountryCode === 'gb' &&
      window.store_country === 'United Kingdom' &&
      isWithinRange(new Date(), new Date(2018, 0, 1), new Date(2018, 1, 1))
    ) {
      setTimeout(() => {
        document.body.classList.add('modal--discount--active')
      }, 3000)
    } else if (!newsletterSeen) {
      setTimeout(() => {
        document.body.classList.add('modal--newsletter--active')
      }, 15000)
    }
  },

  show_au: () => {
      setTimeout(() => {
        const modalSeen = getCookie('seedlip-modal-au', true)

        if (!modalSeen) {
            document.body.classList.add('modal--au--active')
            setCookie('seedlip-modal-au', true, { expires: '1M' })
        }
      }, 1000)
  },

  show_nz: () => {
      setTimeout(() => {
        const modalSeen = getCookie('seedlip-modal-nz', true)

        if (!modalSeen) {
            document.body.classList.add('modal--nz--active')
            setCookie('seedlip-modal-nz', true, { expires: '1M' })
        }
      }, 1000)
  },

  listeners: (consent) => {
    const closeButtons = Array.from(document.querySelectorAll('.c-modal__close, .c-modal__thankyou, [data-close="true"]'))
    const closeNewsletterButtons = Array.from(document.querySelectorAll('.c-modal--newsletter .c-btn'))
    const countryToggles = Array.from(document.querySelectorAll('.c-navigation__country-selector'))

    closeButtons.map((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const modalType = e.target.parentNode.parentNode.classList[1].replace('c-', '')
        const modalTypeActive = `${modalType}--active`

        document.body.classList.remove(modalTypeActive)

        if (modalType === 'modal--discount' && consent) {
          window.sessionStorage.setItem('seedlip_discount', true)
        }
        if (modalType === 'modal--newsletter' && consent) setCookie('seedlip-stored-modal-newsletter', true)
      })

      return true
    })

    closeNewsletterButtons.map((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const data = new URLSearchParams()
        const form = e.target.parentNode

        if (consent) setCookie('seedlip-stored-modal-newsletter', true, { expires: '1M' })

        if (e.target.checkValidity()) {
          for (const pair of new FormData(form)) {
            data.append(pair[0], pair[1])
          }
          if (consent) {
            fetch('https://api.ometria.com/forms/signup', {
              body: data,
              method: 'post',
              mode: 'no-cors',
            })
              .then(res => res.text())
              .then(() => {
                document.body.classList.remove('modal--newsletter--active')
                document.body.classList.add('modal--newsletter-thankyou--active')
              })
              .catch(err => console.error(err))
          } else {
            document.body.classList.remove('modal--newsletter--active')
            document.body.classList.add('modal--newsletter-thankyou--active')
          }
        }
      })

      return true
    })

    countryToggles.map((toggle) => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault()

        document.body.classList.add('modal--store--active')
      })

      return true
    })
  },
}

export default modal
